import * as React from "react";
import FormControl from "@mui/joy/FormControl";
import FormLabel from "@mui/joy/FormLabel";
import CardActions from "@mui/joy/CardActions";
import CardOverflow from "@mui/joy/CardOverflow";
import EmailRoundedIcon from "@mui/icons-material/EmailRounded";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
import { add } from "../../service/clientService";
import { Button } from "primereact/button";
import DropdownApi from "../../components/DropdownApi";
import { UserSession } from "../../models/UserSession";
import AssignmentRoundedIcon from "@mui/icons-material/AssignmentRounded";
import { NprLookup } from "../../service/api-service";
import S3ImagePreview from "../../components/S3ImagePreview";
import { Avatar } from "primereact/avatar";
import { placeholder } from "../../assets/placeholder";
import MultiDropdownApi from "../../components/MultiDropdownApi";
import ImageS3Upload from "../../components/ImageS3Upload";
import { v4 as uuid } from "uuid";
import { addChemical, updateChemical } from "../../service/chemicalService";
import { InputTextarea } from "primereact/inputtextarea";
import { Calendar } from "primereact/calendar";
import { Dropdown, DropdownChangeEvent } from "primereact/dropdown";
import { Grid } from "@mui/material";
import { InputText } from "primereact/inputtext";
import IntervalDropdown from "../../components/IntervalDropdown";
import { TabPanel, TabView } from "primereact/tabview";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";

export default function ChemicalAdd(modalProps: any) {
  const session: UserSession = modalProps.session;

  const id = modalProps?.uuid;

  async function Add() {
    if (!name || name === "") {
      modalProps.toast.current.show({
        severity: "warn",
        summary: "Please enter chemical name",
        life: 3000,
      });
      return;
    }
    if (!chemicalType) {
      modalProps.toast.current.show({
        severity: "warn",
        summary: "Please select chemical type",
        life: 3000,
      });
      return;
    }
    let createObject: any = {
      client: session.client_id,
      name,
      description,
      chemical_type: chemicalType,
      quantity,
      units: unit,
      chemical_safe_checklist: safeChemicalChecklist,
      chemical_risk_checklist: riskChemicalChecklist,
      s3_key: !!file ? `chemical/${id}` : undefined,
    };

    modalProps.setGlobalLoading(true);
    addChemical(createObject).then((r: any) => {
      modalProps.setGlobalLoading(false);
      modalProps.toast.current.show({
        severity: "success",
        summary: "Chemical Added Successfully",
        life: 3000,
      });
      modalProps.setReload(!modalProps.reload);
      modalProps.setVisible(false);
    });
  }

  const interval = [
    {
      id: "Daily",
      name: "Daily",
    },
    {
      id: "Weekly",
      name: "Weekly",
    },
    {
      id: "BI-Weekly",
      name: "BI-Weekly",
    },
    {
      id: "Monthly",
      name: "Monthly",
    },
    {
      id: "Yearly",
      name: "Yearly",
    },
  ];

  const unitsTypes = [
    {
      id: "ml (Millilitres)"
    },
    {
      id: "l (Litres)"
    },
    {
      id: "g (Grams)"
    },
    {
      id: "kg (Kilograms)"
    },
    {
      id: "mg (Milligrams)"
    },
    {
      id: "µg (Micrograms)"
    },
  ]

  const [name, setName] = React.useState("");
  const [description, setDescription] = React.useState("");
  const [chemicalType, setChemicalType] = React.useState("");
  const [chemicalTypeObject, setChemicalTypeObject] = React.useState<any>({});
  const [safeChemicalChecklist, setSafeChemicalChecklist] = React.useState([""]);
  const [riskChemicalChecklist, setRiskChemicalChecklist] = React.useState([""]);
  const [hazard, setHazard] = React.useState<string[]>([]);
  const [quantity, setQuantity] = React.useState("");
  const [unit, setUnit] = React.useState("");

  const [riskAssessment, setRiskAssessment] = React.useState();
  const [photo, setPhoto] = React.useState(placeholder);
  const [file, setFile] = React.useState<File>();

  React.useEffect(() => {
    const risk = chemicalTypeObject?.risk_assessment;
    if (risk) {
      setRiskAssessment(risk);
    }
    const chemical_safe_checklist = chemicalTypeObject?.chemical_safe_checklist;
    if (chemical_safe_checklist) {
      setSafeChemicalChecklist(chemical_safe_checklist);
    }
    const chemical_risk_checklist = chemicalTypeObject?.chemical_risk_checklist;
    if (chemical_risk_checklist) {
      setRiskChemicalChecklist(chemical_risk_checklist);
    }

    const tempHazard: string = chemicalTypeObject?.hazard_list;
    if (tempHazard) {
      setHazard(tempHazard.split(","));
    }
  }, [chemicalType]);

  return (
    <React.Fragment>
      <TabView>
        <TabPanel header="Details">
          <Grid container spacing={2}>
            <Grid item xs={4}>
              <FormControl>
                <ImageS3Upload
                  photo={photo}
                  setPhoto={setPhoto}
                  s3Key={`chemical/${id}`}
                  file={file}
                  setFile={setFile}
                />
              </FormControl>
            </Grid>
            <Grid item xs={8}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <FormControl sx={{ flexGrow: 1 }}>
                    <FormLabel>
                      Name<div style={{ color: "red" }}>*</div>
                    </FormLabel>
                    <FormControl
                      sx={{
                        display: { sm: "flex-column", md: "flex-row" },
                        gap: 2,
                      }}
                    >
                      <InputText
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        type="text"
                        className="p-inputtext-sm PrimeSmallInput"
                      />
                    </FormControl>
                  </FormControl>
                </Grid>

                <Grid item xs={12}>
                  <DropdownApi
                    apiPath="chemical-type"
                    optionLabel="name"
                    optionValue="id"
                    label="Chemical Type"
                    selectedData={chemicalType}
                    setSelectedData={setChemicalType}
                    setSelectedObject={setChemicalTypeObject}
                    required={true}
                  />
                </Grid>
              </Grid>
            </Grid>
            <br />
            <Grid item xs={6}>
              <FormControl sx={{ flexGrow: 1 }}>
                <FormLabel>
                  Quantity
                </FormLabel>
                <FormControl
                  sx={{
                    display: { sm: "flex-column", md: "flex-row" },
                    gap: 2,
                  }}
                >
                  <InputText
                    value={quantity}
                    onChange={(e) => setQuantity(e.target.value)}
                    type="number"
                    className="p-inputtext-sm PrimeSmallInput"
                  />
                </FormControl>
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl sx={{ flexGrow: 1 }}>
                <FormLabel>
                  Units
                </FormLabel>
                <FormControl
                  sx={{
                    display: { sm: "flex-column", md: "flex-row" },
                    gap: 2,
                  }}
                >
                  <Dropdown value={unit} onChange={(e: DropdownChangeEvent) => setUnit(e.value)} options={unitsTypes} optionLabel="id" optionValue="id"
                    placeholder="Select a Unit" style={{ fontSize: 'small', padding: 0 }} className="PrimeSmallInput custom-dropdown" panelClassName="custom-dropdown-panel" />
                </FormControl>
              </FormControl>
            </Grid>
            <br />
            <br />
            <Grid item xs={12}>
              <FormControl>
                <FormLabel>Description</FormLabel>
                <FormControl
                  sx={{
                    display: { sm: "flex-column", md: "flex-row" },
                    gap: 2,
                  }}
                >
                  <InputTextarea
                    value={description}
                    placeholder="Description"
                    onChange={(e) => setDescription(e.target.value)}
                  />
                </FormControl>
              </FormControl>
            </Grid>
            <br />
            {/* <Grid item xs={6}>
          <MultiDropdownApi apiPath='risk-assessment' optionLabel="name" optionValue='id' label='Risk' selectedData={riskAssessment} setSelectedData={setRiskAssessment} />
        </Grid> */}
            <br />
          </Grid>
        </TabPanel>
        <TabPanel header="Checklist">
          <TabView>
            <TabPanel header="Safe">
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <FormControl
                    sx={{ display: { sm: "flex-column", md: "flex-row" } }}
                  >
                    <FormLabel>Questions</FormLabel>
                    <Button
                      type="button"
                      icon="pi pi-plus"
                      label="Add"
                      className="p-button-outlined"
                      size="small"
                      style={{
                        position: "absolute",
                        right: 0,
                        padding: 10,
                        marginTop: -15,
                      }}
                      onClick={() => {
                        const updatedChecklist = [...safeChemicalChecklist];
                        updatedChecklist.push("");
                        setSafeChemicalChecklist(updatedChecklist);
                      }}
                    />
                  </FormControl>
                </Grid>
                {safeChemicalChecklist.map((checklist: any, index: number) => {
                  return (
                    <Grid item xs={12} key={index}>
                      <IconField>
                        <InputIcon
                          className="pi pi-trash"
                          style={{ color: "#eb445a" }}
                          onClick={() => {
                            const updatedChecklist = [...safeChemicalChecklist];
                            updatedChecklist.splice(index, 1);
                            setSafeChemicalChecklist(updatedChecklist);
                          }}
                        >
                          {" "}
                        </InputIcon>
                        <InputText
                          value={checklist}
                          onChange={(e) => {
                            const updatedChecklist = [...safeChemicalChecklist];
                            updatedChecklist[index] = e.target.value;
                            setSafeChemicalChecklist(updatedChecklist);
                          }}
                          style={{ width: "100%" }}
                          type="text"
                          className="p-inputtext-sm PrimeSmallInput"
                          placeholder={`Please enter question ${index + 1}`}
                        />
                      </IconField>
                    </Grid>
                  );
                })}
              </Grid>
            </TabPanel>
            <TabPanel header="At Risk">
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <FormControl
                    sx={{ display: { sm: "flex-column", md: "flex-row" } }}
                  >
                    <FormLabel>Questions</FormLabel>
                    <Button
                      type="button"
                      icon="pi pi-plus"
                      label="Add"
                      className="p-button-outlined"
                      size="small"
                      style={{
                        position: "absolute",
                        right: 0,
                        padding: 10,
                        marginTop: -15,
                      }}
                      onClick={() => {
                        const updatedChecklist = [...riskChemicalChecklist];
                        updatedChecklist.push("");
                        setRiskChemicalChecklist(updatedChecklist);
                      }}
                    />
                  </FormControl>
                </Grid>
                {riskChemicalChecklist.map((checklist: any, index: number) => {
                  return (
                    <Grid item xs={12} key={index}>
                      <IconField>
                        <InputIcon
                          className="pi pi-trash"
                          style={{ color: "#eb445a" }}
                          onClick={() => {
                            const updatedChecklist = [...riskChemicalChecklist];
                            updatedChecklist.splice(index, 1);
                            setRiskChemicalChecklist(updatedChecklist);
                          }}
                        >
                          {" "}
                        </InputIcon>
                        <InputText
                          value={checklist}
                          onChange={(e) => {
                            const updatedChecklist = [...riskChemicalChecklist];
                            updatedChecklist[index] = e.target.value;
                            setRiskChemicalChecklist(updatedChecklist);
                          }}
                          style={{ width: "100%" }}
                          type="text"
                          className="p-inputtext-sm PrimeSmallInput"
                          placeholder={`Please enter question ${index + 1}`}
                        />
                      </IconField>
                    </Grid>
                  );
                })}
              </Grid>
            </TabPanel>
          </TabView>
        </TabPanel>
        {
          hazard && hazard.length > 0 && (
            <TabPanel header="Hazards">
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <FormControl>
                    <FormLabel>Control Measures</FormLabel>
                    <FormControl
                      sx={{
                        display: { sm: "flex-column", md: "flex-row" },
                        gap: 2,
                      }}
                    >
                    </FormControl>
                  </FormControl>
                </Grid>
                {hazard && hazard.map((record: any, index: number) => {
                  return (
                    <Grid item xs={12} key={index}>
                      <IconField>
                        <InputText
                          value={record}
                          readOnly={true}
                          style={{ width: "100%" }}
                          type="text"
                          className="p-inputtext-sm PrimeSmallInput"
                        />
                      </IconField>
                    </Grid>
                  );
                })}
              </Grid>
            </TabPanel>
          )
        }
      </TabView>
      <br />
      <br />
      <CardOverflow
        style={{ width: "100%" }}
        sx={{ borderTop: "1px solid", borderColor: "divider" }}
      >
        <CardActions
          style={{ marginTop: 15 }}
          sx={{ alignSelf: "flex-end", pt: 2 }}
        >
          <Button
            type="button"
            icon="pi pi-save"
            label="Save"
            className="p-button-outlined"
            size="small"
            style={{
              position: "absolute",
              fontSize: "small",
              right: 0,
              color: "#2dd36f",
            }}
            onClick={() => Add()}
          />
        </CardActions>
      </CardOverflow>
    </React.Fragment>
  );
}
